<template>
  <div id="home">


<headers></headers>
        <div class="main mc-index">
                <div class="wrap">
                    <div class="main-in">
                                                <div class="main-front">                            <div class="index" id="index_body">
    <div class="slider" id="index_slider" style="width:1424px;height:790px;margin-top:10px">
        <div id="slider_bd" class="smallslider" style="width:1424px;height:790px">
            <ul style="width:1424px;height:790px">
                <li style="width:1424px;height:790px"><a href="javascript:;"><img src="https://www.giazh.com/uploads/banner.jpg" alt="image1" style="width:1424px;height:790px" /></a></li>
            </ul>
        </div>
    </div>
</div>                    </div>                    </div>
                </div>
            </div>



   <div class="footer">
                <div class="wrap">
                    <div class="footer-in">

                        <div class="footer-navs">
                            <a href="/" class="fn-index on">首页</a><b>|</b>
                            <a href="/vi" class="fn-diamond">在线浏览</a><b>|</b>
                           <a href="/contact" class="fn-login">联系我们</a>
                                                    </div>

                    </div>
                </div>
            </div>



        </div>

</template>

<script>

export default {
  name: 'Home',
  data(){
  return {
  title:"这是我的第一个脚手架项目"
  }
  },
  components:{
  }
}
</script>

<style scoped>
	

    </style>



// WEBPACK FOOTER //
// src/components/Home.vue